const getters = {
  userInfo: state => state.user.userInfo,
  keyCollapse: (state, getters) => getters.screen > 1 ? getters.isCollapse : false,
  token: state => state.user.token,
  roles: state => state.user.roles,
  language: state => state.common.language,
}
export default getters
